import React, { FC, useState } from 'react'
import {
  Input as UIKittenInput,
  InputProps as UIKittenInputProps,
} from '@ui-kitten/components'
import { BtInputLabel } from './BtInputLabel'
import { NativeSyntheticEvent, TextInputFocusEventData } from 'react-native'

export interface BtInputBaseProps extends Omit<UIKittenInputProps, 'label'> {
  label?: string
  required?: boolean
  validate?: (value: string) => string | undefined
  testID?: string
}

export const BtInputBase: FC<BtInputBaseProps> = ({
  label,
  required,
  validate,
  ...uiKittenInputProps
}) => {
  const [validationState, setValidationState] = useState<
    Pick<UIKittenInputProps, 'status' | 'caption'>
  >({})

  const handleFocus = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    if (validate) {
      setValidationState({})
    }

    if (uiKittenInputProps.onFocus) {
      uiKittenInputProps.onFocus(e)
    }
  }

  const handleBlur = (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
    if (validate && uiKittenInputProps.value) {
      const errorMessage = validate(uiKittenInputProps.value)
      const status = errorMessage ? 'danger' : uiKittenInputProps.status
      setValidationState({ status, caption: errorMessage })
    }

    if (uiKittenInputProps.onBlur) {
      uiKittenInputProps.onBlur(e)
    }
  }

  return (
    <UIKittenInput
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      autoComplete={'new-password'}
      {...uiKittenInputProps}
      accessoryRight={<>{uiKittenInputProps.accessoryRight}</>}
      label={label && <BtInputLabel required={required}>{label}</BtInputLabel>}
      onFocus={handleFocus}
      onBlur={handleBlur}
      {...validationState}
    />
  )
}
